import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var GoogleCalendarSvg = function GoogleCalendarSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M19.525 2H4.475c-.798 0-1.445.65-1.445 1.45v15.11c0 .802.647 1.451 1.445 1.451h15.05c.798 0 1.445-.65 1.445-1.45V3.45C20.97 2.65 20.323 2 19.525 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "m8.033 2.9-1.03 1.036L8.94 5.88l1.031-1.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "m16.987 2.869-1.03 1.035 1.955 1.963 1.03-1.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M7.515 4.664c.688 0 1.246-.56 1.246-1.251s-.558-1.25-1.246-1.25-1.245.56-1.245 1.25.557 1.25 1.245 1.25M16.485 4.664c.688 0 1.246-.56 1.246-1.251s-.558-1.25-1.246-1.25-1.246.56-1.246 1.25.558 1.25 1.246 1.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M21.007 13.37H2.981l-.35 7.054c-.01.209.02.417.088.613.066.185.168.355.299.5A1.392 1.392 0 0 0 4.064 22h15.86a1.4 1.4 0 0 0 1.046-.462c.131-.146.233-.316.299-.5.069-.197.098-.405.087-.614z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447BD9",
    d: "M2.993 13.37h18.014l.96-6.655a2 2 0 0 0 0-.725 1.6 1.6 0 0 0-.275-.6 1.341 1.341 0 0 0-1.096-.563H3.454a1.34 1.34 0 0 0-1.096.563c-.151.178-.262.387-.324.612-.045.24-.045.486 0 .726z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M8.263 12.87h.984c.391.04.78-.097 1.059-.376.225-.302.335-.675.311-1.05a1.52 1.52 0 0 0-.349-1.089 1.37 1.37 0 0 0-1.046-.375 1.44 1.44 0 0 0-1.047.388c-.27.27-.415.642-.398 1.025H6.68c-.026-.61.226-1.199.685-1.6a2.6 2.6 0 0 1 1.856-.664 2.65 2.65 0 0 1 1.831.613c.474.455.724 1.095.685 1.751a2 2 0 0 1-1.245 1.764c.436.118.813.395 1.059.775.208.357.315.763.311 1.176a2.26 2.26 0 0 1-.747 1.801 2.78 2.78 0 0 1-1.907.65 2.85 2.85 0 0 1-1.88-.65 1.98 1.98 0 0 1-.71-1.663h1.07c-.018.387.127.764.4 1.038.303.272.702.411 1.108.388.41.024.813-.115 1.121-.388.295-.298.453-.706.436-1.126a1.57 1.57 0 0 0-.361-1.138 1.54 1.54 0 0 0-1.134-.363h-.996zM16.51 17.56h-1.121v-7.142l-2.143.676v-.9l3.264-1.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M15.376 13.37h1.134V8.98l-3.277 1.213v.9l2.143-.688zM6.68 11.406h1.084a1.37 1.37 0 0 1 .399-1.026c.283-.264.66-.404 1.046-.387.386-.03.766.107 1.047.375.253.303.379.694.349 1.088.023.376-.087.749-.312 1.05a1.3 1.3 0 0 1-1.059.376h-.971v.5h2.491l-.261-.125c.739-.3 1.229-1.013 1.245-1.813a2.24 2.24 0 0 0-.685-1.752 2.65 2.65 0 0 0-1.831-.612 2.6 2.6 0 0 0-1.856.662c-.459.402-.71.991-.686 1.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#569DF7",
    d: "m2.98 13.37-.348 7.054c-.012.209.018.417.087.613.066.185.168.355.299.5A1.392 1.392 0 0 0 4.064 22h7.475z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 9.013,
    x2: 9.013,
    y1: 5.345,
    y2: 3.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 17.989,
    x2: 17.989,
    y1: 5.328,
    y2: 3.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 5.472,
    x2: 13.402,
    y1: 19.016,
    y2: 11.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#518DE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5399F4"
  }))));
};
export var GoogleCalendar = function GoogleCalendar(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: GoogleCalendarSvg
  }));
};